import { render, staticRenderFns } from "./EventsTable.vue?vue&type=template&id=7ab66d19&"
import script from "./EventsTable.vue?vue&type=script&lang=js&"
export * from "./EventsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports